import { Card, CardContent } from "@/components/ui/card";
import { Star, Quote } from "lucide-react";

const testimonials = [
  {
    name: "Smt. Priyanka Panda",
    role: "Primary Teacher, Cuttack",
    text: "Earlier I used to spend 30 minutes daily calculating MDM. Now with PM POSHAN Calculator, it takes just 30 seconds. This app is a lifesaver!",
    stars: 5,
  },
  {
    name: "Sri Rajesh Sahoo",
    role: "Headmaster, Balasore",
    text: "Admission time was always stressful — checking eligibility for each student manually. This tool made the process effortless. Highly recommended for all teachers.",
    stars: 5,
  },
  {
    name: "Smt. Gita Mohanty",
    role: "Assistant Teacher, Ganjam",
    text: "I love the Application Writer. Writing leave applications and official letters used to take so much time. Now I generate them in seconds!",
    stars: 5,
  },
  {
    name: "Sri Biswajit Das",
    role: "Teacher, Khordha",
    text: "The Class V & VIII Board Marks Calculator saved me hours of work. ₹199 for the whole year is nothing compared to the time I save every week.",
    stars: 5,
  },
];

export default function TestimonialsSection() {
  return (
    <section data-testid="testimonials-section" className="py-12 md:py-20 bg-white">
      <div className="container mx-auto px-4 md:px-6 max-w-5xl">
        <h2
          data-testid="testimonials-headline"
          className="text-3xl md:text-4xl font-bold text-slate-900 text-center"
          style={{ fontFamily: "'Outfit', sans-serif" }}
        >
          What Teachers Are <span className="text-green-700">Saying</span>
        </h2>
        <p className="mt-3 text-center text-slate-500 text-sm md:text-base">
          Real feedback from Odisha teachers using Teacher Utility Toolkit.
        </p>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-5">
          {testimonials.map((t, i) => (
            <Card
              key={i}
              data-testid={`testimonial-card-${i}`}
              className="bg-white border border-green-100 hover:border-green-200 transition-colors shadow-sm"
            >
              <CardContent className="p-5">
                <Quote className="w-6 h-6 text-green-200 mb-2" />
                <p className="text-sm text-slate-700 leading-relaxed italic">
                  "{t.text}"
                </p>
                <div className="mt-4 flex items-center justify-between">
                  <div>
                    <p className="text-sm font-semibold text-slate-900">{t.name}</p>
                    <p className="text-xs text-slate-500">{t.role}</p>
                  </div>
                  <div className="flex gap-0.5">
                    {Array.from({ length: t.stars }).map((_, s) => (
                      <Star key={s} className="w-3.5 h-3.5 fill-yellow-400 text-yellow-400" />
                    ))}
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
